import React from "react";
import {
	NavLink,
	Link
} from "react-router-dom";
import config from './../../config.js';

import Modal from './../../../components/modal.js';
import Loading from './../../../components/loading.js';
import Actionsheets from './../../../components/actionsheets.js';
import Subject from './subject.js';
import SubjectArchive from './subject_archive.js';

import Editsubject from './edit_subject.js';
import Tagsubject from './tag_subject.js';
import Searchsubject from './search_subject.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class ListSubject extends React.Component {
	constructor(props) {
		super(props);

		let user = {};
		let uistyle = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
			if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
				uistyle = JSON.parse(user.company.type);
			}
		}

		//pathurl used for back url of here when enter into files list
		const pathurl = props.location.pathname + props.location.search;
		const data_type = props.match.params.data_type;
		const offset = props.match.params.offset;

		this.state = {
			pathurl: pathurl,
			user: user,
			projectid: 0,
			groupid: 0,
			data_type: data_type || '',
			//isrequest:true,
			subjects: [],
			loading: false,
			ismodal: false,
			modaltitle: '',
			edit_type: 'editgroup',
			groupname: '',
			isaction: false,
			subject_id: 0,
			subject_name: '',
			subject_age: 50,
			subject_explain: '',
			subject_gender: '',
			subject_uid: '',
			subject_userid: '',
			tasks: [],
			ismodal_download: false,
			downloadurl: '',
			download_message: '',
			checked_subjects: [],
			prototype: [],
			search: '',
			total: 0,
			limit: 15,
			offset: offset || 0,
			pages: 0,
			uistyle: uistyle,
			tagids: [],
			tagname: '',
			ismodal_changegroup: false,
			projects: [],
			groups: [],
			changegroupid: 0,
			change_project_id: 0,
			ismodal_search: false,
			search_list: {}
		}

		this.modalClose = this.modalClose.bind(this);
		this.modalSubmit = this.modalSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.actionClose = this.actionClose.bind(this);
		this.actionSubmit = this.actionSubmit.bind(this);
		this.sync = this.sync.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleProjectChange = this.handleProjectChange.bind(this);
		this.changeGroup = this.changeGroup.bind(this);
		this.modalSearch = this.modalSearch.bind(this);
		this.handleInputSearch = this.handleInputSearch.bind(this);

	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		//console.log(nextProps.project.isrequest);
		const data_type = nextProps.match.params.data_type;
		const offset = nextProps.match.params.offset || 0;
		const pathurl = nextProps.location.pathname + nextProps.location.search;
		//console.log(pathurl)
		self.setState({
			data_type: data_type,
			pathurl: pathurl,
			subjects: [],
			total: 0,
			offset: offset,
			pages: 0,
			search_list: {}
		});
		//console.log(isrequest)
		this.onInitial(data_type, offset)
	}

	componentDidMount() {
		this.sync();
		//this.getPrototype();
	}


	sync() {
		const data_type = this.state.data_type;
		const offset = this.state.offset;
		this.onInitial(data_type, offset);
		this.project_tasks();
	}


	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}


	project_tasks() { //which upload just now and status is 0
		const me = this;
		const postdata = {
			userid: me.state.user.id,
			projectid: me.state.projectid,
			companyid: me.state.user.company_id,
			Authorization: localStorage.token,
			request: 'project_tasks'
		};
		fetch(config.host + '/project/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		}).then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						tasks: json.data
					});
				} else {
					me.setState({
						tasks: []
					});
				}
			});
	}


	removetask(tid) {
		let {
			tasks
		} = this.state;
		tasks.map((task, i) => {
			if (task.id == tid) {
				tasks.splice(i, 1);
			}
		});
		//console.log(tasks)
		this.setState(tasks: tasks);
	}



	onInitial(data_type, offset) {
		const me = this;
		//if(me.state.isrequest===false) return;
		//console.log(offset)
		let {
			projectid,
			groupid,
			search,
			limit,
			pathurl,
			search_list
		} = me.state;

		console.log(search_list)
		let postdata = {
			projectid: projectid,
			groupid: groupid,
			userid: me.state.user.id,
			search: search,
			offset: offset,
			limit: limit,
			data_type: data_type,
			Authorization: localStorage.token,
			request: 'listallsubjects'
		};

		postdata = Object.assign(postdata, search_list);

		console.log(postdata)

		me.setState({
			loading: true
		});

		let prototypes = [];
		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					let subjects = json.data;
					let total = json.total;
					let pages = 0;
					if (subjects !== 'undefined' && subjects.length) {
						subjects.map((item, i) => {
							item.checked = false;
							if (data_type != 'archive' && item.series.length) {
								item.series.forEach(iseries => {
									if (!prototypes.includes(iseries)) prototypes.push(iseries);
								})
							}
						});
					}
					//console.log(20 % 15)
					//console.log(20 / 15)
					pages = total % limit > 0 ? parseInt(total / limit, 10) + 1 : parseInt(total / limit, 10);

					me.setState({
						subjects: subjects,
						prototype: prototypes,
						total: total,
						pages: pages,
						offset: offset
					});
				} else {
					me.setState({
						subjects: [],
						total: 0,
						pages: 0,
						offset: 0
					})
				}
				me.setState({
					loading: false
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	}



	checksubject(subject) {
		const me = this;
		let {
			subjects,
			checked_subjects
		} = me.state;

		if (subjects.length) {
			subjects.map((item, i) => {
				if (item.id === subject.id) {
					item.checked = !item.checked;
					if (item.checked) {
						checked_subjects.push(item.id);
					} else {
						checked_subjects = checked_subjects.filter((ft) => {
							return ft !== item.id
						});
					}


				}
			});


		}

		me.setState({
			subjects: subjects,
			loading: false,
			checked_subjects: checked_subjects
		});

	}


	handleInputChange(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		const type = target.type;

		let tagids = me.state.tagids;
		if (type == "checkbox" && name == "tagid") {
			if (tagids.indexOf(value) >= 0) {
				tagids = tagids.filter((ft) => {
					return ft !== value
				});
			} else {
				tagids.push(value);
			}

			me.setState({
				tagids: tagids
			})
		} else {

			me.setState({
				[name]: value
			})
		}
	}


	modalClose() {
		this.setState({
			ismodal: false,
			loading: false,
			ismodal_download: false,
			ismodal_changegroup: false,
			ismodal_search: false,
			tagids: [],
			tagname: '',
			change_project_id: 0,
			changegroupid: 0,
			projects: [],
			groups: [],
			search_list: {}
		})
	}


	trim(str) {
		return str.replace(/(^\s*)|(\s*$)/g, "");
	}


	modalSubmit() {
		const me = this;
		const {
			edit_type,
			subject_name,
			subject_age,
			tagids,
			tagname
		} = me.state;

		if (edit_type === 'editsubject') {
			if (me.trim(subject_name) === '') {
				me.notify('受试者名称不能为空');
				return;
			}
			if (subject_age.length > 8) {
				me.notify('受试者年龄错误');
				return;
			}
		}

		me.postModal();
	}



	modalSubject(subject, edit_type) {
		if (edit_type === 'editsubject') {
			this.setState({
				ismodal: true,
				edit_type: edit_type,
				modaltitle: '修改受试者信息',
				subject_id: subject.id,
				subject_name: subject.subject_name,
				subject_age: subject.subject_age,
				subject_gender: subject.subject_gender,
				subject_explain: subject.subject_explain || '',
				subject_uid: subject.subject_uid
			});
		}

		if (edit_type === 'tagsubject') {

			let subject_tagids = [];
			if (subject.tags.length) {
				subject.tags.map((t, i) => {
					subject_tagids.push(t.id);
				})
			}
			this.setState({
				ismodal: true,
				edit_type: edit_type,
				modaltitle: '设置标签',
				subject_id: subject.id,
				subject_userid: subject.user_id,
				subject_tags: subject.tags,
				tagids: subject_tagids
			})
		}
	}


	removeSubject(subject) {
		this.setState({
			subject_id: subject.id,
			edit_type: 'removesubject',
			isaction: true
		})
	}

	refreshGroup() {
		const me = this;
		let {
			subjects,
			edit_type,
			subject_id,
			subject_age,
			subject_name,
			subject_gender,
			subject_explain,
			subject_uid
		} = me.state;

		switch (edit_type) {
			case 'removesubject':
				subjects = subjects.filter((ft) => {
					return ft.id !== subject_id
				});
				break;
			case 'editsubject':
				subjects.forEach(s => {
					if (s.id === subject_id) {
						s.subject_age = subject_age;
						s.subject_name = subject_name;
						s.subject_gender = subject_gender;
						s.subject_explain = subject_explain;
						s.subject_uid = subject_uid;
					}
					return s;
				});
				break;
			default:
		}
		me.setState({
			subjects: subjects
		});
	}


	reloadSubjectTags(tags) {
		const me = this;
		let {
			subjects,
			subject_id
		} = me.state;
		subjects.forEach(s => {
			if (s.id === subject_id) {
				s.tags = tags;
			}
			return s;
		});
		me.setState({
			subjects: subjects
		});
	}


	actionClose() {
		this.setState({
			isaction: false
		})
	}


	postModal() {
		const me = this;
		const {
			user,
			projectid,
			edit_type,
			subject_id,
			subject_name,
			subject_age,
			subject_gender,
			subject_explain,
			subject_uid,
			subject_userid,
			tagids,
			tagname
		} = me.state;
		let postdata = '';
		let url = '';
		if (edit_type === 'editsubject') {
			url = config.host + '/project_subject/index';
			postdata = {
				userid: user.id,
				projectid: projectid,
				subject_id: subject_id,
				subject_name: subject_name,
				subject_gender: subject_gender,
				subject_age: subject_age,
				subject_explain: subject_explain,
				subject_uid: subject_uid,
				Authorization: localStorage.token,
				post_type: 'edit'
			};
		}

		if (edit_type === 'tagsubject') {
			url = config.host + '/tags/index';
			postdata = {
				userid: user.id,
				subject_id: subject_id,
				subject_userid: subject_userid,
				tagids: tagids,
				tagname: tagname,
				Authorization: localStorage.token,
				request: 'tagsubject'
			};
		}
		fetch(url, {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				me.notify(json.message);
				if (json.status === 1) {

					me.setState({
						loading: false,
						ismodal: false,
						tagids: [],
						tagname: ''
					});
					if (edit_type === 'editsubject') {
						me.refreshGroup();
					}
					if (edit_type === 'tagsubject') {
						me.reloadSubjectTags(json.data);
					}

				} else {
					me.setState({
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	actionSubmit() {
		const me = this;
		const {
			user,
			projectid,
			groupid,
			edit_type,
			subject_id
		} = me.state;
		me.setState({
			loading: true
		});
		let postdata = '';

		let url = config.host + '/project_subject/index';

		if (edit_type === 'removesubject') {
			postdata = {
				userid: user.id,
				projectid: projectid,
				groupid: groupid,
				subject_id: subject_id,
				Authorization: localStorage.token,
				post_type: 'remove'
			};
		}
		fetch(url, {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(response);
				if (json.status === 1) {
					me.setState({
						loading: false,
						isaction: false
					});

					me.notify(json.message);
					me.refreshGroup();
					return;
				}
				me.setState({
					loading: false,
					isaction: false
				});
				me.notify(json.message);
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	//download single subject's all files with 
	modalDownload(subject, type) { //subject, dicom/nifti
		//console.log('开始zip打包');
		const me = this;
		let {
			user,
			projectid
		} = this.state;

		me.setState({
			loading: true,
			download_message: '正在打包...',
			ismodal_download: true
		});

		const postdata = {
			userid: user.id,
			subjectid: subject.id,
			projectid: projectid,
			companyid: user.company_id,
			Authorization: localStorage.token,
			request: 'download_' + type
		};

		fetch(config.host + '/download/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				me.setState({
					loading: false
				});
				if (json.status === 1 && json.downloadurl) {
					me.setState({
						loading: false,
						download_message: '点击下载',
						downloadurl: json.downloadurl
					});
				} else {
					me.setState({
						ismodal_download: false
					});
				}
				me.notify(json.message);
			})
			.catch(function (error) {
				console.log(error);
			});
	}



	download(downtype) {
		console.log('开始zip打包');
		const me = this;
		let {
			user,
			projectid,
			checked_subjects,
			data_type
		} = this.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}

		me.setState({
			loading: true,
			download_message: '正在打包' + checked_subjects.length + '项受试者文件...',
			ismodal_download: true
		});

		const postdata = {
			userid: user.id,
			subjects: checked_subjects,
			projectid: projectid,
			companyid: user.company_id,
			data_type: data_type,
			Authorization: localStorage.token,
			request: downtype
		};

		fetch(config.host + '/download/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				me.setState({
					loading: false
				});
				if (json.status === 1 && json.downloadurl) {
					me.setState({
						loading: false,
						download_message: '点击下载',
						downloadurl: json.downloadurl
					});
				} else {
					me.setState({
						ismodal_download: false
					});
				}
				me.notify(json.message);
			})
			.catch(function (error) {
				console.log(error);
			});

	}

	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		const me = this;
		const {
			data_type,
			offset
		} = me.state;

		me.onInitial(data_type, offset);
		me.modalClose();
		return;
	}

	onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.handleSubmit();
		}
	}

	/**
	 * [change_group description]
	 * @return {[type]} [description]
	 */

	handleProjectChange(event) {
		const target = event.target;
		console.log(target.value)
		this.setState({
			change_project_id: target.value
		});
		this.state.projects.map((m, i) => {
			if (m.id == target.value) {
				this.setState({
					groups: m.groups,
					changegroupid: m.groups[0]['id']
				});
			}
		})
	}

	change_group() {
		const me = this;
		let {
			checked_subjects,
			user
		} = this.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}

		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			Authorization: localStorage.token,
			request: 'project_groups'
		};

		console.log(postdata)
		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				if (json.status == 1) {
					let groups = json.data[0]['groups'];
					let changegroupid = json.data[0]['groups'][0]['id'];
					let change_project_id = json.data[0]['groups'][0]['project_id'];
					me.setState({
						loading: false,
						ismodal_changegroup: true,
						projects: json.data,
						groups: groups,
						changegroupid: changegroupid,
						change_project_id: change_project_id
					});
				} else {
					me.setState({
						loading: false
					});
					me.notify(json.message);
				}
			})
			.catch(function (error) {
				console.log(error);
			});

	}


	changeGroup() {
		console.log('开始更换分组');
		const me = this;
		let {
			user,
			checked_subjects,
			change_project_id,
			changegroupid
		} = me.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}


		if (changegroupid == 0 || changegroupid == '') {
			me.notify('请选择要更换的分组');
			return;
		}

		me.notify('正在更换' + checked_subjects.length + '项受试者文件...');
		me.setState({
			loading: true
		});
		const postdata = {
			userid: user.id,
			subjects: checked_subjects,
			change_project_id: change_project_id,
			changegroupid: changegroupid,
			companyid: user.company_id,
			Authorization: localStorage.token,
			request: 'change_project_group'
		};

		console.log(postdata)
		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				me.notify(json.message);
				if (json.status === 1) {
					me.setState({
						loading: false,
						ismodal_changegroup: false,
						checked_subjects: [],
						changegroupid: 0,
						projects: [],
						groups: [],
						change_project_id: 0
					});
					me.sync();
				} else {
					me.setState({
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	removetask(taskid) {
		const me = this;
		let {
			user,
			tasks
		} = me.state;
		me.setState({
			loading: true
		});
		const postdata = {
			id: taskid,
			userid: user.id,
			companyid: user.company_id,
			projectid: 0,
			Authorization: localStorage.token,
			request: 'remove_encrypt_task'
		};

		console.log(postdata)
		fetch(config.host + '/project/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				me.notify(json.message);
				if (json.status == 1) {
					tasks.map((t, i) => {
						if (t.id == taskid) {
							tasks.splice(i, 1);
						}
					});
					me.setState({
						loading: false,
						tasks: tasks
					});
				} else {
					me.setState({
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	modalSearch() {
		this.setState({
			ismodal_search: true
		})
	}


	handleInputSearch(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		const type = target.type;
		let search_list = me.state.search_list;

		console.log(value)
		search_list[name] = value;
		me.setState({
			search_list: search_list
		})

	}


	render() {
		const me = this;
		let pagination = []
		let {
			tasks,
			data_type,
			download_message,
			downloadurl,
			prototype,
			subjects,
			projectid,
			groupid,
			pathurl,
			total,
			limit,
			offset,
			pages,
			uistyle,
			projects,
			change_project_id,
			groups,
			changegroupid,
			search_list
		} = me.state;
		prototype = prototype.length ? prototype.sort() : [];
		//console.log(groups)
		if (pages > 1) {
			for (let i = 0; i < pages; i++) {
				pagination.push(<li className={`page-item ${i == offset ? "active" : ""}`} key={i}><Link to={`/console/list_subjects/${data_type}/${i}`} className="page-link">{i + 1}</Link></li>);
			}

		}

		return (
			<div className="mb-3 pb-3">
				<nav className="clearfix mb-3">
					<div className="float-right"><a onClick={this.modalSearch} className="btn btn-sm">高级搜索</a></div>
					<h4 className="animated fadeInLeft float-left"><i className="fa fa-data"></i> 受试者列表 <small>共{total}条</small></h4>
					<div className="float-right">
						<form className="form-inline" onSubmit={this.handleSubmit}>
							<div className="form-group">
								<input type="search" name="search" className="form-control form-control-sm" placeholder="受试者编号、年龄、性别等" onChange={this.handleInputChange} onBlur={this.handleSubmit} value={this.state.search} style={{ 'minWidth': '200px' }} />
							</div>
							<button type="submit" className="btn btn-dark btn-sm">搜索</button>
						</form>
					</div>
					<div className="float-right animated fadeInLeft  mr-2"> <Link className="btn btn-sm btn-danger" to={`/console/upload_subject/${projectid}/${groupid}/0`}>添加受试者</Link>
					</div>

					<div className="btn-group  btn-group-sm float-right mr-2 animated fadeInRight" role="group" >
						<Link to={`/console/list_subjects/0/0`} className={`btn btn-sm px-3 ${data_type == '' || data_type == 0 ? "btn-primary text-light" : "btn-outline-secondary"}`} >影像</Link>
						<Link to={`/console/list_subjects/archive/0`} className={`btn btn-sm px-3 ${data_type == 'archive' ? "btn-primary text-light" : "btn-outline-secondary"}`}  >其它</Link>
					</div>
				</nav>
				<Loading display={this.state.loading} />
				{
					tasks.length > 0 && tasks.map((t, i) => {
						return (
							<div className="clearfix text-right text-muted alert alert-warning" key={i}>
								{t.status === '2' &&
									<span className="float-left">
										<a className="cursor" onClick={() => me.removetask(t.id)}><i className="fa fa-minus-circle"></i></a>
									</span>
								}
								<span className="float-right">
									{t.file_name} 上传时间：{t.date_created}  {t.status === '0' ? '正在处理，大约需要一分钟' : '刷新查看结果'} <a className="cursor ml-3" onClick={me.sync}><i className="fa fa-sync"></i></a>
								</span>
							</div>
						)
					})
				}

				{
					subjects.length === 0 && <p className="text-center text-muted py-5 my-5 shadow-sm">没有数据</p>
				}

				{
					subjects.length > 0 &&
					<div className="card_list">
						<table className="table  table-striped table-hover">
							<thead>
								<tr>
									<th width="33%">受试者</th>
									{data_type !== 'archive' && uistyle.is_subjectuid && <th width="10%">UID</th>}
									<th width="15%">创建时间</th>
									{data_type !== 'archive' && <th>模态</th>}
									{data_type !== 'archive' && <th>标签</th>}
									<th className="text-right">操作</th>
								</tr>
							</thead>
							<tbody>
								{
									data_type !== 'archive' && subjects.map((item, key) => {

										return (
											<Subject key={key} data={{ prototype: prototype, subject: item, projectid: projectid, data_type: data_type, pathurl: pathurl, uistyle: uistyle }} checksubject={this.checksubject.bind(this)} modalSubject={this.modalSubject.bind(this)} modalDownload={this.modalDownload.bind(this)} removeSubject={this.removeSubject.bind(this)}
											/>
										)
									})
								}

								{
									data_type == 'archive' && subjects.map((item, key) => {

										return (
											<SubjectArchive key={key} data={{ subject: item, projectid: projectid, data_type: data_type, pathurl: pathurl }} checksubject={this.checksubject.bind(this)} modalSubject={this.modalSubject.bind(this)} modalDownload={this.modalDownload.bind(this)} removeSubject={this.removeSubject.bind(this)}
											/>
										)
									})
								}
							</tbody>
						</table>
					</div>
				}

				<div className="clearfix mt-5">
					{pages > 1 &&
						<div className="float-left">
							<nav>
								<ul className="pagination">
									{pagination}
								</ul>
							</nav>
						</div>
					}

					<div className="px-3 text-right float-right">

						{
							data_type !== 'archive' &&
							<button type="button" className="btn btn-primary btn-sm" onClick={() => { this.download('download_subjects') }}><i className="fa fa-download"></i> 批量下载</button>
						}
						{
							data_type === 'archive' &&
							<button type="button" className="btn btn-primary btn-sm" onClick={() => { this.download('download_archive') }}><i className="fa fa-download"></i> 批量下载</button>
						}
						{uistyle.is_project &&
							<button type="button" className="btn btn-info btn-sm ml-3" onClick={() => { this.change_group() }}><i className="fa fa-people-carry"></i> 添加至项目分组</button>}

					</div>
				</div>



				<Modal title={this.state.modaltitle} display={this.state.ismodal} close={this.modalClose} submit={this.modalSubmit}>
					{
						this.state.edit_type === 'editgroup' && <div className="form-group row">
							<label className="col-sm-2 col-form-label text-right">分组名称：</label>
							<div className="col-sm-10">
								<input type="text" className="form-control" placeholder="Group Name ..." name="groupname" value={this.state.groupname} onChange={this.handleInputChange} autoFocus="autofocus" maxLength="60" />
							</div>
						</div>
					}

					{
						this.state.edit_type === 'editsubject' && <Editsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
					}

					{
						this.state.edit_type === 'tagsubject' && <Tagsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
					}
				</Modal>

				<Modal title='提醒' display={this.state.ismodal_download} close={this.modalClose} submit={this.modalClose} hidefooter="true">
					<div className="text-center">
						{
							downloadurl === '' && <span>{download_message}</span>
						}
						{downloadurl !== '' && <a className="btn btn-primary my-3" target="_blank" href={downloadurl}><i className="fa fa-download"></i> {download_message}</a>}
					</div>
				</Modal>


				<Modal title='选择项目及分组' display={this.state.ismodal_changegroup} close={this.modalClose} submit={this.changeGroup}>
					<form >
						<div className="form-group row">
							<label className="col-sm-4 col-form-label text-right">选择项目：</label>
							<div className="col-sm-8">
								<select name="change_project_id" className="form-control" onChange={this.handleProjectChange} value={change_project_id}>

									{
										projects.length > 0 && projects.map((item, index) => {
											return <option value={item.id} key={index}>{item.name}</option>
										})
									}
								</select>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-4 col-form-label text-right">选择分组：</label>
							<div className="col-sm-8">
								<select name="changegroupid" className="form-control" onChange={this.handleInputChange} value={changegroupid}>
									{
										groups.length > 0 && groups.map((s, i) => {
											return (<option value={s.id} key={i}>{s.name}</option>)

										})
									}
								</select>
							</div>
						</div>
					</form>
				</Modal>



				<Modal title='高级搜索' display={this.state.ismodal_search} close={this.modalClose} submit={this.handleSubmit}>
					<Searchsubject handleInputSearch={this.handleInputSearch.bind(this)} search_list={search_list} />
				</Modal>

				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item" onClick={this.actionSubmit}>删除</li>
						<li className="list-group-item  text-danger" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/list_subjects.js